export default {
	widgets: [
		{ label: 'To learn', count: 'getToLearnCards', color: 'text-green-7' },
		{ label: 'Known', count: 'getKnownCards', color: 'text-blue-5' },
		{ label: 'Learned', count: 'getLearnedCards', color: 'text-orange-5' }
	]
}
